// @ts-nocheck
// import logo from './logo.svg';
import './App.css';
import Navigation from './navigation';
import React from 'react';

function App() {
  return (
    <div className="App">
      <Navigation />
    </div>
  );
}

export default App;
